import { create } from 'zustand'

export const usePurchaseFrequencyStore = create(set => ({
  dateExpiryStart: null,
  setDateExpiryStart: dateExpiryStart => set(() => ({ dateExpiryStart })),
  dateExpiryEnd: null,
  setDateExpiryEnd: dateExpiryEnd => set(() => ({ dateExpiryEnd })),
  isLoading: false,
  setIsLoading: loading => set(() => ({ isLoading: loading })),
  purchaseFrequencyData: [],
  setPurchaseFrequencyData: purchaseFrequencyData =>
    set(() => ({ purchaseFrequencyData })),
  purchaseFrequencyTotal: 0,
  setPurchaseFrequencyTotal: purchaseFrequencyTotal =>
    set(() => ({ purchaseFrequencyTotal })),
  barsValue: 0,
  setBarsValue: value => set(() => ({ barsValue: value })),
  barsPData: [],
  setBarsPData: data => set(() => ({ barsPData: data })),
  barsXLabels: [],
  setBarsXLabels: labels => set(() => ({ barsXLabels: labels })),
  barsPDataByDays: [],
  setBarsPDataByDays: data => set(() => ({ barsPDataByDays: data })),
  barsXLabelsByDays: [],
  setBarsXLabelsByDays: labels => set(() => ({ barsXLabelsByDays: labels })),
  uniqueUsersTotal: 0,
  setUniqueUsersTotal: uniqueUsersTotal => set(() => ({ uniqueUsersTotal })),
  purchasesTotal: 0,
  setPurchasesTotal: purchasesTotal => set(() => ({ purchasesTotal })),
  resetStore: () =>
    set(() => ({
      dateExpiryStart: null,
      dateExpiryEnd: null,
      isLoading: false,
      invoicesData: [],
      barsValue: 0,
      barsPData: [],
      barsXLabels: [],
      barsPDataByDays: [],
      barsXLabelsByDays: [],
      purchaseFrequencyData: [],
      purchaseFrequencyTotal: 0,
      uniqueUsersTotal: 0,
      purchasesTotal: 0,
    })),
}))
